import { AutocompleteSearchField } from '~/shared/forms/controls/base-fields/AutocompleteSearchField';
import { useQueryDataTableFilter } from '~/shared/data-tables/query/useQueryDataTableFilter';

export function PhysicianQueryDataFilter({ fieldName }: { fieldName: string }) {
	const [value, setValue] = useQueryDataTableFilter({
		name: fieldName,
		convertFromQueryParam: value => value.toString()
	});
	return (
		<AutocompleteSearchField
			label="Physician"
			hideLabel
			placeholder="All Physicians"
			searchType="physician"
			value={value}
			onChange={id => setValue(id)}
		/>
	);
}
